"use client";

import React from "react";
import { faqsData } from "./faqData";
import FAQAccordion from "@/components/ui/faq";

const FAQSection: React.FC = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-8">
      {/* Title */}
      <div className="w-full max-w-[702px] text-balance text-center text-4xl font-semibold leading-9 text-foreground lg:text-6xl lg:leading-none">
        Frequently Asked Questions
      </div>

      <FAQAccordion
        data={faqsData.map((faq, index) => ({ id: index, ...faq }))}
        showAllLimit={7}
        initialOpenIndex={0}
        containerClassName="max-w-[760px]"
      />
    </div>
  );
};

export default FAQSection;
